import * as Yup from "yup";

export const initialValues = {
  name: undefined,
};

export const ValidationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required."),
});
